import { render, staticRenderFns } from "./4group.vue?vue&type=template&id=c9e45f86&scoped=true&"
import script from "./4group.vue?vue&type=script&lang=js&"
export * from "./4group.vue?vue&type=script&lang=js&"
import style0 from "./4group.vue?vue&type=style&index=0&id=c9e45f86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e45f86",
  null
  
)

export default component.exports